import {
  cloneVNode,
  defineComponent,
  isVNode,
  provide,
  reactive,
  toRef,
} from 'vue'
import { flattedChildren } from '@zoryn/utils'
import ZTooltip from '@zoryn/components/tooltip'
import { useNamespace } from '@zoryn/hooks'
import ZAvatar from './avatar.vue'
import { avatarGroupContextKey } from './constants'
import { avatarGroupProps } from './avatar-group-props'

export default defineComponent({
  name: 'ZAvatarGroup',
  props: avatarGroupProps,
  setup(props, { slots }) {
    const ns = useNamespace('avatar-group')

    provide(
      avatarGroupContextKey,
      reactive({
        size: toRef(props, 'size'),
        shape: toRef(props, 'shape'),
      })
    )

    return () => {
      const avatars = flattedChildren(slots.default?.() ?? [])
      let visibleAvatars = avatars

      const showCollapseAvatar =
        props.collapseAvatars && avatars.length > props.maxCollapseAvatars

      if (showCollapseAvatar) {
        visibleAvatars = avatars.slice(0, props.maxCollapseAvatars)
        const hiddenAvatars = avatars.slice(props.maxCollapseAvatars)

        visibleAvatars.push(
          <ZTooltip
            popperClass={props.popperClass}
            popperStyle={props.popperStyle}
            placement={props.placement}
            effect={props.effect}
            disabled={!props.collapseAvatarsTooltip}
          >
            {{
              default: () => (
                <ZAvatar
                  size={props.size}
                  shape={props.shape}
                  class={props.collapseClass}
                  style={props.collapseStyle}
                >
                  + {hiddenAvatars.length}
                </ZAvatar>
              ),
              content: () => (
                <div class={ns.e('collapse-avatars')}>
                  {hiddenAvatars.map((node, idx) =>
                    isVNode(node)
                      ? cloneVNode(node, { key: node.key ?? idx })
                      : node
                  )}
                </div>
              ),
            }}
          </ZTooltip>
        )
      }

      return <div class={ns.b()}>{visibleAvatars}</div>
    }
  },
})
